import axios from 'axios';
import * as qs from 'qs';

const defaultJsonHeaders = {
  'Content-Type': 'application/json',
};

const multipartHeaders = {
  'Content-Type': 'multipart/form-data',
};
const paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: 'repeat' });
};

export function requestGet(url, params) {
  return new Promise((resolve, reject) => {
    axios({ url, params, paramsSerializer }).then(dataResolver(resolve), errorRejector(reject));
  });
}

export function requestPut(url, data) {
  return new Promise((resolve, reject) => {
    axios({ url, data, method: 'PUT' }).then(dataResolver(resolve), errorRejector(reject));
  });
}

export function requestPatch(url, data) {
  return new Promise((resolve, reject) => {
    axios({ url, data, method: 'PATCH' }).then(dataResolver(resolve), errorRejector(reject));
  });
}

export function requestDelete(url) {
  return new Promise((resolve, reject) => {
    axios({ url, headers: defaultJsonHeaders, method: 'DELETE' }).then(dataResolver(resolve), errorRejector(reject));
  });
}

export function requestPost(url, data) {
  return new Promise((resolve, reject) => {
    axios({ url, data, headers: defaultJsonHeaders, method: 'POST' }).then(dataResolver(resolve), errorRejector(reject));
  });
}

export function requestPostForm(url, data) {
  return new Promise((resolve, reject) => {
    axios({ url, data, headers: multipartHeaders, method: 'POST' }).then(dataResolver(resolve), errorRejector(reject));
  });
}

const dataResolver = (resolve) => (response) => resolve(response.data);
const errorRejector = (reject) => (error) => reject(error);
